module.exports = __webpack_public_path__ + "static/media/superior.f3be1fa0.png";